import { BookOpen, Globe2 } from "lucide-react";
import { BlogCityPicker } from "@/components/BlogCityPicker";

const HERO_IMG = "https://images.unsplash.com/photo-1777542845598-60088139ad6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";
const t = (lang, ru, en, tr) => (lang === "tr" ? tr : (lang === "en" ? en : ru));

export function BlogHero({ lang, city, total, citiesCount, onCityChange }) {
  return (
    <section className="relative overflow-hidden bg-[#faf6f1] border-b border-stone-200/70" data-testid="blog-hero">
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-pink-100/60 blur-3xl pointer-events-none" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 pt-8 pb-10 sm:pt-14 sm:pb-16 grid md:grid-cols-12 gap-8 md:gap-10 items-center">
        <div className="md:col-span-7 animate-[fadeIn_.6s_ease-out]">
          <span className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-pink-600" data-testid="blog-hero-eyebrow">
            <span className="w-6 h-px bg-pink-500" />
            {t(lang, "Журнал YUCCA Flowers", "The YUCCA Flowers Journal", "YUCCA Flowers Dergisi")}
          </span>
          <h1 className="mt-4 font-['Playfair_Display',serif] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-stone-900" data-testid="blog-title">
            {t(lang, "Блог о цветах", "Stories about", "Çiçekler")}{" "}
            <em className="italic text-pink-600">{t(lang, "и доставке", "flowers & delivery", "ve teslimat")}</em>
          </h1>
          <p className="mt-4 text-sm sm:text-base text-stone-600 max-w-md leading-relaxed" data-testid="blog-hero-subtitle">
            {t(lang,
              "Гиды по городам, советы по выбору букета и ответы на частые вопросы о заказе цветов.",
              "City guides, bouquet tips and answers to common questions about ordering flowers.",
              "Şehir rehberleri, buket ipuçları ve çiçek siparişi hakkında sık sorulan sorular.")}
          </p>
          <div className="mt-6">
            <BlogCityPicker city={city} lang={lang} onChange={onCityChange} />
          </div>
          <div className="mt-5 flex items-center gap-5 text-xs text-stone-500">
            <span className="inline-flex items-center gap-1.5" data-testid="blog-hero-articles-count">
              <BookOpen className="w-3.5 h-3.5 text-pink-500" />
              <b className="text-stone-800">{total}</b> {t(lang, "статей", "articles", "makale")}
            </span>
            <span className="inline-flex items-center gap-1.5" data-testid="blog-hero-cities-count">
              <Globe2 className="w-3.5 h-3.5 text-pink-500" />
              <b className="text-stone-800">{citiesCount}</b> {t(lang, "городов", "cities", "şehir")}
            </span>
          </div>
        </div>
        <div className="md:col-span-5 relative hidden sm:block">
          <div className="absolute -bottom-3 -left-3 w-full h-full rounded-[2rem] bg-pink-200/50" />
          <img
            src={HERO_IMG}
            alt={t(lang, "Букет цветов в вазе", "Flower bouquet in a vase", "Vazoda çiçek buketi")}
            className="relative w-full aspect-[4/5] max-h-[420px] object-cover rounded-[2rem] shadow-xl"
            data-testid="blog-hero-image"
          />
        </div>
      </div>
    </section>
  );
}
